import { RouteObject } from "react-router-dom";
import { ServicePartnersCollectionList } from "@/pages/admin/servicepartner-collections/ServicePartnerCollectionList";
import { ServicePartnersCollectionCreate } from "@/pages/admin/servicepartner-collections/ServicePartnerCollectionCreate";
import { ServicePartnersCollectionEdit } from "@/pages/admin/servicepartner-collections/ServicePartnerCollectionEdit";
import { ServicePartnersCollectionDetail } from "@/pages/admin/servicepartner-collections/ServicePartnerCollectionDetail";

export const servicePartnersCollectionsRoutes: RouteObject[] = [
  {
    id: "collections-list",
    index: true,
    element: <ServicePartnersCollectionList />,
  },
  {
    id: "collections-create",
    path: "create",
    element: <ServicePartnersCollectionCreate />,
  },
  {
    id: "collections-edit",
    path: ":id/edit",
    element: <ServicePartnersCollectionEdit />,
  },
  {
    id: "collections-detail",
    path: ":id",
    element: <ServicePartnersCollectionDetail />,
  },
];
